import { definePreset } from '@primeuix/themes';
import Nora from '@primeuix/themes/nora';

const HubWebTheme = definePreset(Nora, {
  //Your customizations, see the following sections for examples
  components: {
    popover: {
      root: {
        background: '#FFFFFF',
        borderColor: '#FFFFFF',
        color: '#212121',
      }
    },
    select: {
      root: {
        background: '#FFFFFF',
        color: '#000000',
        placeholderColor: '#000000',
        borderRadius: '4px',
        borderColor: '#E8E8E8',
        focusBorderColor: '#FCB026',
        hoverBorderColor: '#FCB026',
        focusRing: {
          color: '#FCB026'
        }
      },
      dropdown: {
        color: '#3A3A3A',
      },
      overlay: {
        background: '#FFFFFF',
        color: '#212121',
        borderColor: '#E8E8E8',
        borderRadius: '4px',
      },
      option: {
        color: '#212121',
        focusBackground: '#F4F4F4',
        focusColor: '#212121',
        selectedBackground: '#FCB026',
        selectedFocusBackground: '#FCB026',
        selectedFocusColor: '#212121',
        selectedColor: '#212121',
      }
    },
    dialog: {
      root: {
        background: '#FFFFFF',
        color: '#000000',
        borderColor: '#E8E8E8',
        borderRadius: '4px',
      },
      title: {
        fontSize: '18px',
      },
      content: {
        padding: '1.25rem',
      },
      css: () => `
        .p-dialog-close-button.p-button-text.p-button-secondary {
          color: #787878;
        }
        .p-dialog-content {
          border-top-width: 1px;
          border-top-color: #E8E8E8;
        }
      `
    },
    tabs: {
      tablist: {
        background: '#F7F7F7',
        borderColor: '#00000000'
      },
      tab: {
        activeBackground: '#FFFFFF',
        activeColor: '#212121',
        color: '#212121',
        background: '#F7F7F7',
        borderWidth: '1px',
        fontWeight: '100',
        hoverBackground: '#e2e8f0',
        hoverColor: '#0f172a'
      },
      tabpanel: {
        background: '#FFFFFF',
        color: '',
      },
      navButton: {
        background: '#F7F7F7',
        hoverColor: '#A1A1AA'
      },
      css: () => `
        .p-tab {
          font-size: 14px;
        }
        .p-tab-active {
          border-color: #E8E8E8 #E8E8E8 #FCB026 #E8E8E8;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
        .p-tab:not(.p-tab-active):not(.p-disabled):hover {
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
        }
      `
    },
    card: {
      body: {
        padding: '4px',
      },
      root: {
        background: '#FFFFFF',
      },
      subtitle: {
        color: '#000000',
      }
    },
    selectbutton: {
      root: {
        borderRadius: '4px',
      }
    },
    togglebutton: {
      root: {
        borderColor: '#FFFFFF',
        checkedBackground: '#FCB026',
        checkedBorderColor: '#FFFFFF',
        checkedColor: '#000000',
        background: '#FFFFFF',
        color: '#000000',
      },
      css: () => `
        .p-togglebutton.p-togglebutton-checked {
          font-weight: bold;
        }
      `
    },
    scrollpanel: {
      bar: {
        size: '5px',
        background: '#FCB026', // This doesn't work, so I've had to use css below (Thanks PrimeNG). I've left this here so it doesn't confuse someone in the future.
      },
      css: () => `
        .p-scrollpanel-bar {
          background: #FCB026;
        }
      `
    }
  },
});

export default HubWebTheme;
